import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { TOASTER_VARIANT } from '../../components/toast/constants';
import { COMMON_LOADING_STATES, PAGE_STATE } from '../constants/constants';
import { addNotifications } from '../toaster/ToasterPortalSlice';
import { componentKey, setAssigneeList, setLoadingState, setNoticeList, setPayersList, setShowAddNoticePopup, setTotalData } from './NoticeSectionSlice';
import NoticesDataService from '../../../services/NoticesDataService';
import { setActions, setGridData } from './NoticeSectionSlice';
import { NOTICES_STATES } from './constants';

export const { getList, deleteNotice, toggleArchiveNotice, getAddNoticeDropDownData, getAssigneeList, saveNotice } = {
    getList: (payload) => {
        return {
            type: "NOTICES/GET_LIST",
            payload: payload
        }
    },
    deleteNotice: (payload) => {
        return {
            type: "NOTICES/DELETE_NOTICE",
            payload: payload
        }
    },
    toggleArchiveNotice: (payload) => {
        return {
            type: "NOTICES/TOGGLE_ARCHIVE_NOTICE",
            payload: payload
        }
    },
    getAddNoticeDropDownData: (payload) => {
        return {
            type: "NOTICES/GET_ADD_NOTICE_DROPDOWN_DATA",
            payload: payload
        }
    },
    getAssigneeList: (payload) => {
        return {
            type: "NOTICES/GET_ASSIGNEE_LIST",
            payload: payload
        }
    },
    saveNotice: (payload) => {
        return {
            type: "NOTICES/SAVE_NOTICE",
            payload: payload
        }
    },
}


function* getListAsync(action) {
    try {
        yield put(setLoadingState({ state: NOTICES_STATES.GRID_LOADING }))
        
        const { NoticeName, page, pageSize} = action.payload;
        
        const params = {
            NoticeName: NoticeName || "",
			page: page || 1,
			pageSize: pageSize || 10
        }
        
        const response = yield NoticesDataService.getList(params);
        if (response.data.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: "Error in fetching notices list",
                variant: TOASTER_VARIANT.DANGER
            }));
        } else {
            yield put(setGridData(response.data.Data.Data.Data))
            yield put(setTotalData(response.data.Data.Data.Total))
            yield put(setActions(response.data.Data.ActionList))

        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: NOTICES_STATES.GRID_READY }))
    }
}

function* deleteNoticeAsync(action) {
    try {
        yield put(setLoadingState({ state: NOTICES_STATES.GRID_LOADING }))
        const response = yield NoticesDataService.removeNotice(action.payload);
        if (response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getListAsync, { payload: {}})
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data.MessageDetail,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: NOTICES_STATES.GRID_READY }))
    }
}

function* toggleArchiveNoticeAsync(action) {
    try {
        yield put(setLoadingState({ state: NOTICES_STATES.GRID_LOADING }))
        const response = yield NoticesDataService.toggleArchiveNotice(action.payload);
        if (response.data.Status === 1) {
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
            yield call(getListAsync, { payload: {}})
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data.MessageDetail,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: NOTICES_STATES.GRID_READY }))
    }
}

function* getAddNoticeDropDownDataAsync(action) {
    try {
        yield put(setLoadingState({ state: NOTICES_STATES.POPUP_LOADING}));
        const response = yield NoticesDataService.addNoticeDropDownData(action.payload);
        if (response.data.Status === 1) {
            yield put(setPayersList(response.data.Data.PayerList))
            yield put(setNoticeList(response.data.Data.NoticeList))
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data.MessageDetail,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: NOTICES_STATES.POPUP_READY }))
    }
}

function* getAssigneeListAsync(action) {
    try {
        yield put(setLoadingState({ state: NOTICES_STATES.POPUP_LOADING}));
        const response = yield NoticesDataService.addNoticeGetAssigneeByPayerId(action.payload);
        if (response.data.Status === 1) {
            yield put(setAssigneeList(response.data.Data))
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data.MessageDetail,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: NOTICES_STATES.POPUP_READY }))
    }
}

function* saveNoticeAsync(action) {
    try {
        yield put(setLoadingState({ state: NOTICES_STATES.POPUP_LOADING }));
        const response = yield NoticesDataService.saveNotice(action.payload);
        if (response.data.Status === 1) {
            yield put(setShowAddNoticePopup(false))
            yield call(getListAsync, { payload: {}})
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: response.data.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: NOTICES_STATES.POPUP_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getList().type, getListAsync),
        takeLatest(deleteNotice().type, deleteNoticeAsync),
        takeLatest(toggleArchiveNotice().type, toggleArchiveNoticeAsync),
        takeLatest(getAddNoticeDropDownData().type, getAddNoticeDropDownDataAsync),
        takeLatest(getAssigneeList().type, getAssigneeListAsync),
        takeLatest(saveNotice().type, saveNoticeAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);